import { render, staticRenderFns } from "./SurfInlineTwoImageText.vue?vue&type=template&id=91536aee&scoped=true"
import script from "./SurfInlineTwoImageText.vue?vue&type=script&setup=true&lang=js"
export * from "./SurfInlineTwoImageText.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SurfInlineTwoImageText.vue?vue&type=style&index=0&id=91536aee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91536aee",
  null
  
)

export default component.exports